import {PlaylistAddCheck} from "@mui/icons-material";
import * as React from "react";

const PersonTodoIcon = ({person}) => {
    return (
        <>
            {
                person?.hasOwnProperty("todos") && person.todos?.data?.length > 0 &&
                    <PlaylistAddCheck sx={{
                        fontSize: '20px',
                        color: `${person.todos?.data[0].kpi_criteria?.color_code}`}}/>
            }
        </>
    )
}

export default PersonTodoIcon;